/*eslint no-unused-vars:0 no-trailing-spaces:0 */
let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
let React = require("ES/lib/react");
let radio = require("ES/lib/radio");
let Modal = require("ES/widgets/Modal");
let esUtils = require("ES/utils/esUtils");
let AuthedUserSession = require("../../../../../utils/AuthedUserSession");

/**
 * THIS LOGIC IS DUPLICATED IN include/class.Event.php,
 * so if you make changes here, you need to make the same changes there.
 *
 * For a particular todomaster item, create a todoevent item set correctly for this event.
 *
 * @param event
 * @param master_list
 * @returns {{eid, from_list_id: *, vieworder, id: number}}
 */
let masterlistToEventTodo = function (event, master_list) {
  let new_todo = {
    id: 0,
    eid: event.eid,
    from_list_id: master_list.id > 1 ? master_list.id : master_list._list_id,
    vieworder: master_list.vieworder,
    action_type: master_list.action_type,
    todomaster_id: master_list._todo_id,
    email_recipient_group: _.isString(master_list.email_recipient_group) ? master_list.email_recipient_group : "",
    action_foreign_id: master_list.action_foreign_id,
  };
  new_todo.description = master_list.description;
  if (master_list.duebasedon === "STRT") {
    //STRT - event start date
    new_todo.statusdate = _.isDate(event.starttime)
      ? new Date(event.starttime.getTime())
      : new Date();
  } else if (master_list.duebasedon === "STAT") {
    //STAT - event status change date (which is now)
    new_todo.statusdate = new Date();
  } else {
    new_todo.statusdate = null;
  }
  if (
    _.isDate(new_todo.statusdate) &&
    _.isNumber(master_list.duedelta) &&
    !_.isNaN(master_list.duedelta)
  ) {
    new_todo.statusdate.setDate(
      new_todo.statusdate.getDate() + master_list.duedelta
    );
  }
  new_todo.assignedto = _.isString(master_list.assignedto)
    ? master_list.assignedto
    : "";
  new_todo.assignedto = new_todo.assignedto.replace(
    /\[ME\]/i,
    (AuthedUserSession.balboa &&
      AuthedUserSession.balboa.username &&
      AuthedUserSession.balboa.username.toUpperCase()) ||
      "me"
  );
  return new_todo;
};

module.exports = dd.createClass({
  propTypes: {
    event: React.PropTypes.object.isRequired,
    Displaylists: React.PropTypes.object.isRequired,
    onClose: React.PropTypes.func.isRequired,
    list_id: React.PropTypes.number.isRequired,
    custom_clear_message: React.PropTypes.string, //optional
  },
  getInitialState() {
    return { should_apply_lists: null, should_clear_lists: null };
  },
  __hasBeenAskedToApplyLists() {
    let applicable_items = this.__getApplicable_items();
    //either they clicked yes OR there are no items, thus only asked if they want to clear it
    return (
      null !== this.state.should_apply_lists || applicable_items.length === 0
    );
  },
  __hasBeenAskedToClearLists() {
    let { event } = this.props;
    //either they clicked yes OR the current list is already empty
    return (
      null !== this.state.should_clear_lists ||
      (event && _.isEmpty(event.EventTodo))
    );
  },
  __getApplicable_items() {
    let { event, Displaylists, list_id } = this.props;
    let common_actionlists_sid = _.get(
      Displaylists,
      "universal.USE_COMMON_ACTIONLISTS_SID",
      -1
    );
    let todoIds = [];
    let master_lists;
    if (AuthedUserSession.is_st_family) {
      //TEAM-ADMIN privatelabels that use only shared actionlists

      let event_company_id = _.get(event, "companyID", 2);
      let todolists = _.get(
        Displaylists,
        ["universal", "todolists", event_company_id, "lists"],
        []
      );
      todolists = _.filter(todolists, function (todolist) {
        return todolist.id == list_id;
      });
      master_lists = _.map(todolists, function (todolist) {
        return _.map(todolist.masters, function (master_list, id) {
          master_list._todo_id = id;
          master_list._sid = common_actionlists_sid;
          master_list._list_id = todolist.id;
          return master_list;
        });
      });
      master_lists = _.flatten(master_lists);
    } else {
      //normal SPEAKER-BASED action-lists
      master_lists = _.flattenDeep(
        _.map(
          _.filter(Displaylists && Displaylists.perspeaker, function (spkr) {
            return (
              _.includes(event.sids, spkr.sid) ||
              spkr.sid == common_actionlists_sid
            );
          }),
          function (spkr) {
            return _.map(
              _.filter(spkr.todolists, function (todolist) {
                return todolist.id == list_id;
              }),
              function (todolist) {
                return _.map(todolist.masters, function (master_list, id) {
                  master_list._todo_id = id;
                  master_list._sid = spkr.sid;
                  master_list._list_id = todolist.id;
                  return master_list;
                });
              }
            );
          }
        )
      );
    }

    let applied_ids = [];
    let master_lists_cleaned = [];
    _.each(master_lists, function (each) {
      if (!_.includes(applied_ids, each._todo_id)) {
        master_lists_cleaned.push(each);
        applied_ids.push(each._todo_id);
      }
    });

    let status_map = _.object(
      _.map(
        Displaylists &&
          Displaylists.universal &&
          Displaylists.universal.eventstatuses,
        function (status) {
          return [status.id, status.description];
        }
      )
    );
    return _.filter(master_lists_cleaned, function (master) {
      if(master.activateonstatus === -1){
        return true;
      }
      return event.status === status_map[master.activateonstatus];
    });
  },
  componentDidUpdate() {
    //once all the choices are made, apply them
    if (
      this.__hasBeenAskedToApplyLists() &&
      this.__hasBeenAskedToClearLists()
    ) {
      this.__applyList();
    }
  },
  /**
   * Apply the selected actionlist to this event, setting each item appropriately
   * based on this event's date, etc.
   *
   * @private
   */
  __applyList() {
    let event = _.cloneDeep(this.props.event);
    let { list_id } = this.props; //Displaylists
    let applicable_items = this.state.should_apply_lists
      ? this.__getApplicable_items()
      : [];
    let originalTodolistids = event.todolistids;
    let needsSave = false;

    if (this.state.should_clear_lists || !_.isArray(event.EventTodo)) {
      event.EventTodo = [];
      needsSave = true;
    }
    //iterate over each item in the new list and create a todoevent item for this event
    _.each(applicable_items, function (master_list) {
      event.EventTodo.push(masterlistToEventTodo(event, master_list));
      needsSave = true;
    });

    //allow multiple actionlists per event
    /*
         if (!_.isArray(event.todolistids)) {
         event.todolistids = [];
         }
         let my_sids = esUtils.cleanup_ids(_.map(Displaylists && Displaylists.perspeaker, 'sid'));
         _.each(_.intersection(event.sids, my_sids), function (sid) {
         let alreadyInList = false;
         _.each(event.todolistids, function (list) {
         if ((list.sid == sid) && (list.listid == list_id)) {
         alreadyInList = true;
         }
         });
         if (!alreadyInList) {
         event.todolistids.push({sid: parseInt(list_sid, 10), listid: parseInt(list_id, 10)});
         }
         });
         */

    //single Actionlist per event
    event.todolistids = [_.parseInt(list_id)]; //must be integers

    needsSave = needsSave || !_.isEqual(originalTodolistids, event.todolistids);
    if (needsSave) {
      radio("save_Event").broadcast(event);
    }
    this.props.onClose(); //close it b/c the event details area will handle applying these changes
  },
  __onYesApply: esUtils.wrapPreventDefault(function () {
    //componentDidUpdate() takes care of applying once all the choices are made
    this.setState({ should_apply_lists: true });
  }),
  __onNoApply: esUtils.wrapPreventDefault(function () {
    this.setState({ should_apply_lists: false });
  }),
  __onYesClear: esUtils.wrapPreventDefault(function () {
    this.setState({ should_clear_lists: true });
  }),
  __onNoClear: esUtils.wrapPreventDefault(function () {
    this.setState({ should_clear_lists: false });
  }),

  render() {
    let { event, onClose, custom_clear_message } = this.props;

    // This line keeps action item lists from updating if both are blank
    // if (this.__hasBeenAskedToApplyLists() && this.__hasBeenAskedToClearLists()) return null;

    let whichModal = this.__hasBeenAskedToApplyLists()
      ? "askclear"
      : "askapply";
    let applicable_items = this.__getApplicable_items();

    return Modal(
      {
        title: "Add action items?",
        onClose: onClose,
        buttons: [],
      },
      dd.div(
        { className: "row" },
        dd.div(
          { className: "col-sm-2" },
          dd.i({
            className: "fa fa-warning text-muted",
            style: { fontSize: 64 },
          })
        ),
        dd.div(
          { className: "col-sm-10" },
          whichModal == "askclear"
            ? dd.div(
                null,
                dd.p(
                  null,
                  custom_clear_message ||
                    "You are changing the action lists for this event."
                ),
                dd.p(null, "Do you want to CLEAR THE CURRENT list?")
              )
            : dd.div(
                null,
                dd.p(
                  null,
                  "Add " +
                    applicable_items.length +
                    ' applicable Action Items for the status "' +
                    event.status +
                    '"?'
                )
              )
        )
      ),
      dd.div(
        { className: "text-center" },
        dd.button(
          {
            className: "btn btn-primary",
            onClick:
              whichModal === "askclear" ? this.__onYesClear : this.__onYesApply,
          },
          "Yes"
        ),
        " ",
        dd.button(
          {
            className: "btn btn-default",
            onClick:
              whichModal === "askclear" ? this.__onNoClear : this.__onNoApply,
          },
          "No"
        )
      )
    );
  },
});



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/action_list/ApplyListModal.js